import React, { useState, useEffect } from 'react'
import { db } from "../../config/firebase"


const SchoolCommonData = ({school}) => {

   const collectionName = school + "Common"

   const [e, setE] = useState({})
   const [f, setF] = useState({})
   const [g, setG] = useState({})

   useEffect(() => {
      db.collection(collectionName).get()
         .then((querySnapshot) => {
            setE(querySnapshot.docs[0].data())
            setF(querySnapshot.docs[1].data())
            setG(querySnapshot.docs[2].data())
         })
         .catch(err => console.log(err))
   }, [collectionName])



   return (
      <>
         <div className="course-wrap course-e">
            <table>
               <thead>
                  <tr><th colSpan="2">E 学びエイド</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>個別・寺子屋・クラス受講回数</td>
                     <td>月謝</td>
                  </tr>
                  <tr>
                     <td>個別なし</td>
                     <td>{e.l1}</td>
                  </tr>
                  <tr>
                     <td>週１コマ受講生</td>
                     <td>{e.l2}</td>
                  </tr>
                  <tr>
                     <td>週２コマ受講生</td>
                     <td>{e.l3}</td>
                  </tr>
                  <tr>
                     <td>週３コマ受講生</td>
                     <td>{e.l4}</td>
                  </tr>
                  <tr>
                     <td>週４コマ受講生</td>
                     <td>{e.l5}</td>
                  </tr>
                  <tr>
                     <td>※端末貸出月額（希望者）</td>
                     <td>{e.l6}</td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               日本最高峰の予備校講師が100名以上集結。30,000コマ以上、中1基礎から最難関大学レベルまでの全科目の授業が受講し放題。<br/>
               月曜日7限（8：20～9：50）に設定です。<br/>
               毎回の授業時のミニセミナー（20分～30分）では40年以上のキャリアで学び経験した様々な受験必勝法を伝授します。<br/>
               中2・高2から受講するのがベストです。<br/>
               偏差値27（チャレンジ支援の高校3年生）からMARCHレベルの大逆転合格者や東工大・早稲田・上智の合格者が天心塾でこれを受講。<br/>
               ※　学びエイドを追加で申し込まない場合でも１日３コマまでの受講は無料です。<br/>
            </p>
         </div>

         <div className="course-wrap course-f">
            <table>
               <thead>
                  <tr><th colSpan="2">F ビットキャンパスタッチ5教科対応タブレット学習定着システム</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>月謝</td>
                     <td>端末貸出月額（希望者）</td>
                  </tr>
                  <tr>
                     <td>{f.l1}</td>
                     <td>{f.l2}</td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               スタンダードかプレミアム個別指導を受講の方は個別指導の授業以外に週1回の講師指導管理の演習授業がついています。<br/>
               授業は理解や思考が中心ですが、ビットキャンパスタッチはコンピュータの力で演習や知識の定着や暗記を主な目的にしています。<br/>
               寺子屋とクラス授業のコースの方は追加オプション（月額1,500円）でH.演習授業をとることができ授業回数が1回増えます。<br/>
            </p>
         </div>
         <div className="course-wrap course-g">
            <table>
               <thead>
                  <tr><th colSpan="1">G 学校教科書対応映像授業（中学生限定）</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>{g.l1}</td>
                  </tr>
               </tbody>
            </table>
            <p className="desc">
               国語と英語は各出版社完全対応で、数学・理科・社会は単元別構成です。
            </p>
         </div>
      </>
   )
}


export default SchoolCommonData